import {
    GET_PAGE,
    GET_PAGE_SUCCESS,
    GET_PAGE_FAIL,
} from "./action"

const initialState = {
    title: 'Loading...',
    content: 'Loading...'
}

export default function (state = initialState, action) {
    switch (action.type) {
        case GET_PAGE:
            return { ...state }
        case GET_PAGE_SUCCESS:
            return {
                ...action.payload
            }
        case GET_PAGE_FAIL:
            return { title: "No Content", content: "No Content" }
        default: return { ...state }
    }
}


// WEBPACK FOOTER //
// ./src/components/page/reducer.js